/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as r from "react";
import { InstanceObserver as c } from "@progress/kendo-charts";
import { hasParent as h } from "../utils/index.mjs";
import { Popup as u } from "@progress/kendo-react-popup";
import { MapContext as f } from "../MapContext.mjs";
const v = { horizontal: "fit", vertical: "fit" }, d = ["k-tooltip", "k-map-tooltip"], O = "k-tooltip-wrapper", p = class p extends r.Component {
  constructor(t, e) {
    super(t, e), this.context = null, this.element = null, this.onMapMouseLeave = (o) => {
      const { syntheticEvent: s } = o;
      return !!h(s.relatedTarget, this.element);
    }, this.mapObserver = new c(this, {
      onMouseLeave: "onMapMouseLeave"
    }), e.observersStore.dispatch({
      type: "add",
      payload: this.mapObserver
    });
  }
  render() {
    const { popupShown: t, popupAlign: e, popupOffset: o, popupStyles: s, popupContent: a, className: i } = this.props, m = [...d, i].join(" ").trim();
    return /* @__PURE__ */ r.createElement(
      u,
      {
        animate: !0,
        popupAlign: e,
        offset: o,
        show: t,
        collision: v,
        className: O
      },
      /* @__PURE__ */ r.createElement("div", { className: m, style: s, ref: (l) => this.element = l }, a())
    );
  }
  componentWillUnmount() {
    this.context.observersStore.dispatch({
      type: "remove",
      payload: this.mapObserver
    });
  }
};
p.contextType = f;
let n = p;
export {
  n as TooltipPopup
};
